import { id } from "./id";

type ProjectStrategicAxis = {
  strategicAxisId: string;
  weight: number;
  consistencyValue: number;
};

const projectStrategicAxis: ProjectStrategicAxis = {
  strategicAxisId: id,
  weight: 0,
  consistencyValue: 0,
};

export type { ProjectStrategicAxis };

export { projectStrategicAxis };
